import { supabase } from "../supabaseClient";

const apiBaseUrl = (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "") || (typeof window !== "undefined" ? window.location.origin : "");

const getFreshSession = async () => {
  const { data: { session }, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) throw new Error(sessionError.message || "Please sign in first.");

  const expiresSoon = !session?.expires_at || session.expires_at <= Math.floor(Date.now() / 1000) + 60;
  if (session && expiresSoon) {
    const { data: refreshed, error: refreshError } = await supabase.auth.refreshSession();
    if (refreshError || !refreshed.session) {
      throw new Error(refreshError?.message || "Your session has expired. Please sign in again.");
    }
    return refreshed.session;
  }

  return session;
};

const request = async (path, options = {}) => {
  let session = await getFreshSession();
  if (!session?.access_token) throw new Error("Please sign in first.");

  let response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${session.access_token}`, ...(options.headers || {}) },
  });

  if (response.status === 401) {
    const { data: refreshed, error: refreshError } = await supabase.auth.refreshSession();
    if (!refreshError && refreshed.session) {
      session = refreshed.session;
      response = await fetch(`${apiBaseUrl}${path}`, {
        ...options,
        headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${session.access_token}`, ...(options.headers || {}) },
      });
    }
  }

  const payload = await response.json().catch(() => null);
  if (!response.ok || payload?.status === "error") throw new Error(payload?.message || "Promotion request failed.");
  return payload;
};

export const loadActivePromotions = async () => {
  const response = await fetch(`${apiBaseUrl}/api/promotions`, { headers: { Accept: "application/json" } });
  const payload = await response.json().catch(() => null);
  if (!response.ok || payload?.status === "error") throw new Error(payload?.message || "Unable to load promotions.");
  return payload.promotions || [];
};

export const loadAdminPromotions = async () => request("/api/admin/promotions");
export const createCampaign = async (payload) => (await request("/api/admin/promotions/campaigns", { method: "POST", body: JSON.stringify(payload) })).campaign;
export const updateCampaign = async (id, payload) => (await request(`/api/admin/promotions/campaigns/${id}`, { method: "PATCH", body: JSON.stringify(payload) })).campaign;
export const deleteCampaign = async (id) => request(`/api/admin/promotions/campaigns/${id}`, { method: "DELETE" });
export const createPromoCode = async (payload) => (await request("/api/admin/promotions/codes", { method: "POST", body: JSON.stringify(payload) })).promo_code;
export const updatePromoCode = async (id, payload) => (await request(`/api/admin/promotions/codes/${id}`, { method: "PATCH", body: JSON.stringify(payload) })).promo_code;
export const deletePromoCode = async (id) => request(`/api/admin/promotions/codes/${id}`, { method: "DELETE" });
export const createGiftCard = async (payload) => (await request("/api/admin/promotions/gift-cards", { method: "POST", body: JSON.stringify(payload) })).gift_card;
export const updateGiftCard = async (id, payload) => (await request(`/api/admin/promotions/gift-cards/${id}`, { method: "PATCH", body: JSON.stringify(payload) })).gift_card;
export const disableGiftCard = async (id) => request(`/api/admin/promotions/gift-cards/${id}`, { method: "DELETE" });

export const validatePromoCode = async (code) => (await request("/api/payment/validate-promo", { method: "POST", body: JSON.stringify({ promoCode: code }) }));
